
import { Action, createAction, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { eventsActions } from './events.era'

export interface EntitiesState {
  typeIds: string[]
}

const getDefaultEntitiesState = (): EntitiesState => ({
  typeIds: []
})

export const entitiesActions = createActionGroup({
  source: 'Entities',
  events: {
    'Set Type Ids': (typeIds: string[]) => ({ typeIds })
  }
})

export const entitiesReducer = createReducer(
  getDefaultEntitiesState(),
  on(entitiesActions.setTypeIds, (state, { typeIds }) => ({ ...state, typeIds })),
  on(eventsActions.unloadEvent, (state) => getDefaultEntitiesState())
)

export const entitiesFeature = createFeature({
  name: 'entities',
  reducer: entitiesReducer
})

export const entitiesStateSelector = createFeatureSelector<EntitiesState>(entitiesFeature.name)
